import SpoilerViewerWrapper from "./Components/Wrappers/SpoilerViewerWrapper";
import { SPOILER_TYPE } from "./types";
import { initSpoilersContentState } from "./utils/spoilerUtilsFn";
import nodeViewDecorator from "./nodeViewDecorator";
const pluginSpoiler = (config) => {
  return {
    config: { initSpoilersContentState, SpoilerViewerWrapper, ...config },
    type: SPOILER_TYPE,
    nodeViewDecorators: [nodeViewDecorator]
  };
};
export {
  SpoilerViewerWrapper,
  initSpoilersContentState,
  pluginSpoiler
};
//# sourceMappingURL=viewer.js.map
